module.exports = __webpack_public_path__ + "static/media/bed2x.7bcc4ad7.png";